<div class="cf-flex-column cf-justify-content-space-between cf-align-items-center">
  <div class="full-width notification-container cf-flex-1 cf-flex-row cf-justify-content-space-between cf-align-items-center cf-gap-10">
    <div>
      @if (isSuccess) {
        <mat-icon aria-hidden="true" aria-label="success icon" class="icon">done_outline</mat-icon>
      }
      @if (!isSuccess) {
        <mat-icon aria-hidden="true" aria-label="success icon" class="icon">error_outline</mat-icon>
      }
    </div>
    <div class="message cf-flex-1" [innerHtml]="data.message | translate: parameters"></div>
    <button mat-button (click)="dismiss()">
      <span [translate]="'UI.Dismiss'"></span>
    </button>
  </div>
  <mat-progress-bar
    class="notification-progressBar"
    [ngClass]="{ error: !isSuccess, success: isSuccess }"
    mode="determinate"
    [value]="progressBarValue"
  ></mat-progress-bar>
</div>
